import React from "react"

export default function Container({children, classes, rowclasses, id})
{       
    const c = classes !== undefined ? ' '+classes : ''
    const r = rowclasses !== undefined ? ' '+rowclasses : ''
    
    return (id ?
        <div id={id} className={"container"+c}>
            <div className={"row"+r}>
                {children}
            </div>      
        </div>
        :
        <div className={"container"+c}>
            <div className={"row"+r}>
                {children}
            </div>      
        </div>
    ) 
}